const BASE_URL = "/checkout-branding";

export const PAGE_URLS = {
  legacyDetails: `${BASE_URL}`,
  details: `${BASE_URL}/v2`,
  legacyEdit: `${BASE_URL}/edit`,
  edit: `${BASE_URL}/v2/edit`,
};
